<template>
  <div id="student_list">
    <div class="list_view list_flex">
      <a-menu style="width: 200px" mode="vertical" :defaultSelectedKeys="['1']" :selectedKeys="[stuSelectKey]" @click="handleClick">
        <a-menu-item key="1">
          <router-link to="/studentList/studentInfo">学生列表</router-link>
        </a-menu-item>
        <a-menu-item key="2">
          <router-link to="/studentList/amendInfo">待修正学生信息</router-link>
        </a-menu-item>
      </a-menu>
      <div class="list_con">
        <router-view/>
      </div>
    </div>
    <div v-if="editUpdateGrade" class="edit_grade">
      <div class="edit_warp list_flex">
        <div class="edit_box">
          <div class="edit_top">更改学校年级设置</div>
          <div class="edit_middle">
            <span>请选择学校中包含的年级</span>
            <div class="edit_part">
              <div>
                <div>
                  <a-checkbox :indeterminate="indeterminate" @change="onCheckAllChange" :checked="checkAll">小学</a-checkbox>
                </div>
                <a-checkbox-group :options="plainOptions" v-model="checkedList" @change="onChange" />
              </div>
            </div>
            <div class="edit_part">
              <div>
                <div>
                  <a-checkbox :indeterminate="indeterminateTwo" @change="onCheckAllChangeTwo" :checked="checkAllTwo">初中</a-checkbox>
                </div>
                <a-checkbox-group :options="plainOptionsTwo" v-model="checkedListTwo" @change="onChangeTwo" />
              </div>
            </div>
            <div class="edit_part">
              <div>
                <div>
                  <a-checkbox :indeterminate="indeterminateThree" @change="onCheckAllChangeThree" :checked="checkAllThree">高中</a-checkbox>
                </div>
                <a-checkbox-group :options="plainOptionsThree" v-model="checkedListThree" @change="onChangeThree" />
              </div>
            </div>
            <div class="edit_part">
              <div>
                <div>
                  <a-checkbox :indeterminate="indeterminateFour" @change="onCheckAllChangeFour" :checked="checkAllFour">大学</a-checkbox>
                </div>
                <a-checkbox-group :options="plainOptionsFour" v-model="checkedListFour" @change="onChangeFour" />
              </div>
            </div>
          </div>
          <div class="edit_bottom list_flex">
            <a-button @click="updateRemoveHandle" style="margin-right: 8px;">取消</a-button>
            <a-button type="primary" :disabled="checkDisable" @click="updateSubmitHandle">提交</a-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const plainOptions = ['一年级', '二年级', '三年级', '四年级', '五年级', '六年级']
const plainOptionsTwo = ['初一年级', '初二年级', '初三年级']
const plainOptionsThree = ['高一年级', '高二年级', '高三年级']
const plainOptionsFour = ['大学一年级', '大学二年级', '大学三年级', '大学四年级']
import { mapActions, mapState, mapMutations } from 'vuex'
import STUDENTFUN from '@/util/studentFun'

export default {
  name: 'StudentList',
  data () {
    return {
      indeterminate: false,
      indeterminateTwo: false,
      indeterminateThree: false,
      indeterminateFour: false,
      checkAll: false,
      checkAllTwo: false,
      checkAllThree: false,
      checkAllFour: false,
      plainOptions,
      plainOptionsTwo,
      plainOptionsThree,
      plainOptionsFour,
      checkedList: [],
      checkedListTwo: [],
      checkedListThree: [],
      checkedListFour: []
    }
  },
  computed: {
    ...mapState([
      'schoolGrades',
      'editUpdateGrade',
      'teacherAdmin',
      'stuSelectKey'
    ]),
    checkDisable () {
      if (this.checkedList.length !== 0 || this.checkedListTwo.length !== 0 || this.checkedListThree.length !== 0 || this.checkedListFour.length !== 0) {
        return false
      } else {
        return true
      }
    }
  },
  mounted () {
    if (this.schoolGrades) {
      this.schoolGrades.map(item => {
        if (plainOptions.includes(item)) {
          this.checkedList.push(item)
        } else if (plainOptionsTwo.includes(item)) {
          this.checkedListTwo.push(item)
        } else if (plainOptionsThree.includes(item)) {
          this.checkedListThree.push(item)
        } else {
          this.checkedListFour.push(item)
        }
      })
    }
  },
  methods: {
    ...mapActions([
      'getUserInfo',
      'updateSchoolGrades'
    ]),
    ...mapMutations([
      'setEditUpdateGrade',
      'setSelectKey',
      'setGradesMaxMin'
    ]),
    handleClick(e) {
      console.log('click ', e)
      this.setSelectKey(e.key)
    },
    onChange (checkedList) {
      this.indeterminate = !!checkedList.length && checkedList.length < plainOptions.length
      this.checkAll = checkedList.length === plainOptions.length
    },
    onChangeTwo (checkedList) {
      this.indeterminateTwo = !!checkedList.length && checkedList.length < plainOptionsTwo.length
      this.checkAllTwo = checkedList.length === plainOptionsTwo.length
    },
    onChangeThree (checkedList) {
      this.indeterminateThree = !!checkedList.length && checkedList.length < plainOptionsThree.length
      this.checkAllThree = checkedList.length === plainOptionsThree.length
    },
    onChangeFour (checkedList) {
      this.indeterminateFour = !!checkedList.length && checkedList.length < plainOptionsFour.length
      this.checkAllFour = checkedList.length === plainOptionsFour.length
    },
    onCheckAllChange (e) {
      console.log(e)
      Object.assign(this, {
        checkedList: e.target.checked ? plainOptions : [],
        indeterminate: false,
        checkAll: e.target.checked
      })
    },
    onCheckAllChangeTwo (e) {
      console.log(e)
      Object.assign(this, {
        checkedListTwo: e.target.checked ? plainOptionsTwo : [],
        indeterminateTwo: false,
        checkAllTwo: e.target.checked
      })
    },
    onCheckAllChangeThree (e) {
      console.log(e)
      Object.assign(this, {
        checkedListThree: e.target.checked ? plainOptionsThree : [],
        indeterminateThree: false,
        checkAllThree: e.target.checked
      })
    },
    onCheckAllChangeFour (e) {
      console.log(e)
      Object.assign(this, {
        checkedListFour: e.target.checked ? plainOptionsFour : [],
        indeterminateFour: false,
        checkAllFour: e.target.checked
      })
    },
    updateRemoveHandle () {
      this.setEditUpdateGrade(false)
    },
    async updateSubmitHandle () {
      if (this.checkedList.length !== 0 || this.checkedListTwo.length !== 0 || this.checkedListThree.length !== 0 || this.checkedListFour.length !== 0) {
        let grade = [...this.checkedList, ...this.checkedListTwo, ...this.checkedListThree, ...this.checkedListFour]
        let aaaf = (array) => { // 连续选择年级
          let isContinuityArray = true
          array.map((item, index) => {
            if (index < array.length - 1) {
              let current = array[index].id - 1
              if (array[index + 1].id !== current) {
                isContinuityArray = false
              }
            }
          })
          return isContinuityArray
        }
        if (aaaf(STUDENTFUN.gradeFunction(grade))) { // 判断所选年级是否连续
          let userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
          let result = {
            ROLE_ID: userInfo.role_id,
            SCHOOL_ID: userInfo.school_id,
            UID: this.teacherAdmin.uid,
            DATA: {
              MAX_GRADE: STUDENTFUN.gradeFunction(grade)[0].id,
              MIN_GRADE: STUDENTFUN.gradeFunction(grade)[grade.length - 1].id
            }
          }
          try {
            await this.updateSchoolGrades(result)
            this.setEditUpdateGrade(false)
            this.$message.success('提交修改年级成功')
            await this.getUserInfo()
            let gradeList = [STUDENTFUN.gradeFunction(grade)[grade.length - 1].id, STUDENTFUN.gradeFunction(grade)[0].id]
            this.setGradesMaxMin(gradeList)
            sessionStorage.setItem('gradeMaxMin', JSON.stringify(gradeList))
          } catch (e) {
            console.log(e)
            this.setEditUpdateGrade(false)
            this.$message.error('提交修改年级失败')
          }
        }
      }
    }
  }
}
</script>

<style>
#student_list {
  width: 100%;
  height: 100%;
}
#student_list .list_flex {
  display: flex;
}
#student_list .list_view {
  width: 100%;
}
#student_list .list_view .list_con {
  flex: 1;
}
.ant-menu {
  background-color: transparent;
  padding-top: 28px;
}
.ant-menu-vertical {
  border: none;
}
.ant-menu-item:hover {
  background: #F5F5F5!important;
}
.ant-menu-item:hover a, .ant-menu-item-selected > a {
  color: #51BF94;
}
.ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {
  background-color: transparent;
}
#student_list > .edit_grade {
  position: fixed;
  z-index: 10000;
  left: 0px;
  right: 0px;
  bottom: 0px;
  top: 0px;
  background-color: rgba(0, 0, 0, .4);
  color: #262626;
  overflow-y: auto;
}
#student_list > .edit_grade .edit_warp {
  width: 100%;
  padding: 140px 0px;
  box-sizing: border-box;
  height: auto;
  justify-content: center;
}
#student_list > .edit_grade .edit_box {
  width: 800px;
  background-color: #FFFFFF;
  border-radius: 4px;
}
#student_list > .edit_grade .edit_top {
  padding: 16px 24px;
  border-bottom: 1px solid #EBEBEB;
  box-sizing: border-box;
  font-size: 16px;
}
#student_list > .edit_grade .edit_middle {
  padding: 32px;
  box-sizing: border-box;
}
#student_list > .edit_grade .edit_middle > span {
  color: #8C8C8C;
}
#student_list > .edit_grade .edit_part {
  margin-top: 32px;
}
#student_list > .edit_grade .ant-checkbox-group {
  margin-top: 16px;
}
#student_list > .edit_grade .edit_bottom {
  padding: 8px 32px;
  border-top: 1px solid #EBEBEB;
  box-sizing: border-box;
  justify-content: flex-end;
}
</style>
